import { AnimatePresence, motion } from "framer-motion";
import { useState } from "react";

const Button = ({
  title,
  bgColor,
  textColor,
  hoverTextColor,
  upperCase,
  round = false
}: Record<string, any>) => {
  const [flag, setFlag] = useState<boolean>(false);
  return (
    // <div
    //   className={`h-full text-[14px] uppercase ${(bgColor?.length === 0)? "bg-orange-600":bgColor} flex overflow-hidden relative w-full`}
    // >
    <div className="relative w-full h-full">
      <button
        className={`relative top-0 left-0 z-20 flex justify-center items-center ${textColor} h-full text-[14px] uppercase ${
          bgColor?.length === 0 ? "" : bgColor
        } flex overflow-hidden w-full font-poppins ${round?'rounded-full':''} font-semibold uppercase before:bg-orange-600 before:h-full before:w-0 before:absolute before:hover:bg-black 
         before:right-0  before:hover:w-full before:transition-all before:duration-[400ms] before:ease-in-out before:-z-[1] before-hover-right-unset before-left-unset`}
      >
        {title}
      </button>
    </div>
  );
};

export default Button;
